import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import parse from 'html-react-parser';
import type { BaseDialogProps } from './BaseDialog';
import BaseDialog from './BaseDialog';

type Props = BaseDialogProps & {
  title: string;
  message: string;
  onAgree: any;
  onDisagree: any;
  agreeLabel?: string;
  disagreeLabel?: string;
  isBusy?: boolean;
};

export default function ConfirmDialog({
  title,
  message,
  onAgree,
  onDisagree,
  agreeLabel = 'Yes',
  disagreeLabel = 'No',
  isBusy = false,
  ...props
}: Props) {
  return (
    <BaseDialog {...props} title={title} onClose={isBusy ? undefined : onDisagree} hideCloseButton={isBusy || props.hideCloseButton}>
      <DialogContent>
        <DialogContentText>{parse(message)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDisagree} disabled={isBusy}>
          {disagreeLabel}
        </Button>
        <Button onClick={onAgree} autoFocus disabled={isBusy}>
          {agreeLabel}
        </Button>
      </DialogActions>
    </BaseDialog>
  );
}
